__turbopack_context__.v({
  "EmailChangeErrorMessage": "LoginBox-module-scss-module__m9wq3q__EmailChangeErrorMessage",
  "ErrorMessage": "LoginBox-module-scss-module__m9wq3q__ErrorMessage",
  "SuccessMessage": "LoginBox-module-scss-module__m9wq3q__SuccessMessage",
  "bold": "LoginBox-module-scss-module__m9wq3q__bold",
  "button": "LoginBox-module-scss-module__m9wq3q__button",
  "buttonContainer": "LoginBox-module-scss-module__m9wq3q__buttonContainer",
  "fallbackWordmark": "LoginBox-module-scss-module__m9wq3q__fallbackWordmark",
  "footer": "LoginBox-module-scss-module__m9wq3q__footer",
  "forgotPasswordLink": "LoginBox-module-scss-module__m9wq3q__forgotPasswordLink",
  "formContent": "LoginBox-module-scss-module__m9wq3q__formContent",
  "formWrapper": "LoginBox-module-scss-module__m9wq3q__formWrapper",
  "grayRectangle": "LoginBox-module-scss-module__m9wq3q__grayRectangle",
  "input": "LoginBox-module-scss-module__m9wq3q__input",
  "inputGroup": "LoginBox-module-scss-module__m9wq3q__inputGroup",
  "loginOptionsContainer": "LoginBox-module-scss-module__m9wq3q__loginOptionsContainer",
  "logoContainer": "LoginBox-module-scss-module__m9wq3q__logoContainer",
  "practiceLogo": "LoginBox-module-scss-module__m9wq3q__practiceLogo",
});
